export default __webpack_public_path__ + "static/media/prugnaTtsIt_It60.277e795b.mp3";